// export const apiURL = (endpoint) => `https://thwsapi.cometo.dev/api/${endpoint}`
export const apiURL = (endpoint) => `https://theinrich.net/website-api/${endpoint}`
